/**
 * What the UI shows for a dictation (Spec § 3.3), derived from the dictation
 * status and the newest draft — never persisted. The stepper (TM-9575) shows
 * `uploaded` and `normalizing` as „Hochgeladen", `transcribing` as
 * „Transkription", `drafting` as „Entwurf", `ready` as „Fertig" and `failed`
 * as „Fehlgeschlagen". A `DISCARDED` dictation has no phase: it is not listed.
 */
export var DictationPhase;
(function (DictationPhase) {
    DictationPhase["UPLOADED"] = "uploaded";
    DictationPhase["NORMALIZING"] = "normalizing";
    DictationPhase["TRANSCRIBING"] = "transcribing";
    DictationPhase["DRAFTING"] = "drafting";
    DictationPhase["READY"] = "ready";
    DictationPhase["FAILED"] = "failed";
    DictationPhase["SAVED"] = "saved";
})(DictationPhase || (DictationPhase = {}));
//# sourceMappingURL=dictation-phase.enum.js.map